import { CssBaseline } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { selectGetAppUserError, selectGetAppUserStatus } from '@features/auth/store/selectors';
import { useEffect } from 'react';
import { getAppUserRequest } from '@features/auth/store';
import { RouterProvider } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { REQUEST_STATUS } from '@shared/constants/otherConstants';
import ErrorPage from '@app/layout/ErrorPage/ErrorPage';
import { AppRouter } from '@app/routes/AppRouter';
import { AlertProvider, ColorModeProvider, LocalizationProvider } from '@app/providers';
import CheckingAuthSpinner from '@shared/components/others/CheckingAuthSpinner/CheckingAuthSpinner';

function App() {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const getAppUserStatus = useSelector(selectGetAppUserStatus);
    const getAppUserError = useSelector(selectGetAppUserError);

    useEffect(() => {
        dispatch(getAppUserRequest());
    }, [dispatch]);

    if (getAppUserStatus === REQUEST_STATUS.LOADING) {
        return <CheckingAuthSpinner />;
    }

    return (
        <>
            <ColorModeProvider>
                <LocalizationProvider>
                    <AlertProvider>
                        <CssBaseline />
                        {getAppUserStatus === REQUEST_STATUS.SUCCESS && <RouterProvider router={AppRouter} />}
                    </AlertProvider>
                </LocalizationProvider>
            </ColorModeProvider>
            {getAppUserStatus === REQUEST_STATUS.ERROR && (
                <ErrorPage
                    errorTitle={t('error')}
                    errorMessage={t('authentication_failed')}
                    errorDetails={JSON.stringify(getAppUserError)}
                />
            )}
        </>
    );
}

export default App;
